import React from 'react';
import PropTypes from 'prop-types';

export default class AccordionHeader extends React.PureComponent {

  handleClick = event => {
    event.preventDefault();
    this.props.toggle();
  };

  render() {
    const { className, isOpen, accordionId, children } = this.props;

    return (
      <a
        href='null'
        className={`rx-accordion-header ${className}`}
        aria-expanded={isOpen}
        aria-controls={accordionId}
        onClick={this.handleClick}>
        <span className='rx-accordion-title'>{children}</span>
        <span className='rx-accordion-state-left'>
          <svg className='els-btn-icon'>
            <use xlinkHref={isOpen ? '#icon-chevron-up' : '#icon-chevron-down'}/>
          </svg>
        </span>
      </a>
    );
  }
}

AccordionHeader.defaultProps = {
  className: '',
  accordionId: '',
};

AccordionHeader.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  accordionId: PropTypes.string,
};
